module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "vulcan-co2-yeargrid-v4.thumbnails.total.a0dc197e.png";